import "../../chunk-7QVYU63E.js";
var CustomerioEvent = /* @__PURE__ */ function(CustomerioEvent2) {
  CustomerioEvent2["SignupComplete"] = "signup_complete";
  CustomerioEvent2["CreatedEmbeddedAccountConfig"] = "created_embedded_account_config";
  CustomerioEvent2["CreatedGasManagerPolicy"] = "created_gas_manager_policy";
  CustomerioEvent2["AutoscaleChanged"] = "autoscale_changed";
  CustomerioEvent2["UsageCapped"] = "usage_capped";
  CustomerioEvent2["UsageCapModified"] = "usage_cap_modified";
  CustomerioEvent2["PaymentMethodModified"] = "payment_method_modified";
  CustomerioEvent2["PlanChanged"] = "plan_changed";
  CustomerioEvent2["ErrorRateAlerted"] = "error_rate_alerted";
  CustomerioEvent2["OnDemandUsageAlerted"] = "on_demand_usage_alerted";
  CustomerioEvent2["DelinquentDowngradeAlerted"] = "delinquent_downgrade_alerted";
  CustomerioEvent2["PaygUpsellRateLimit"] = "PAYG_upsell_email_rate_limit";
  CustomerioEvent2["PaygUpsellPremiumEndpoint"] = "PAYG_upsell_email_premium_endpoint";
  CustomerioEvent2["PaygUpsellGetLogs"] = "PAYG_upsell_email_getlogs";
  CustomerioEvent2["PaygUpsellUsageCap"] = "PAYG_upsell_email_usage_cap";
  return CustomerioEvent2;
}({});
const CIO_TEAM_OBJECT_TYPE_ID = "4";
export {
  CIO_TEAM_OBJECT_TYPE_ID,
  CustomerioEvent
};
//# sourceMappingURL=customerio.js.map